import { httpGet, httpPost, httpPatchMerge, httpDelete } from './../http'
import type { TEntityId } from '~/types/models'
import type { ILeadSourceCampaign } from '~/types/leadSource/models'

const apiEntityPath = '/api/leadsourcecampaigns'

export async function getLeadSourceCampaigns() {
  const callingMn = getLeadSourceCampaigns.name
  const apiPath = `${apiEntityPath}`
  return httpGet<ILeadSourceCampaign[]>({ callingMn, apiPath })
}

export async function createLeadSourceCampaign(entity: ILeadSourceCampaign) {
  const callingMn = createLeadSourceCampaign.name
  const apiPath = apiEntityPath
  return httpPost<ILeadSourceCampaign>({ callingMn, apiPath, entity })
}

export async function updateLeadSourceCampaign(
  entityData: Partial<ILeadSourceCampaign>,
  id: TEntityId
) {
  const callingMn = updateLeadSourceCampaign.name
  const apiPath = `${apiEntityPath}/${id}`
  type TPartialLeadSourceCampaign = Partial<ILeadSourceCampaign>
  return httpPatchMerge<TPartialLeadSourceCampaign>({
    callingMn,
    apiPath,
    entityData,
  })
}

export async function deleteLeadSourceCampaign(
  entityData: ILeadSourceCampaign
) {
  const callingMn = deleteLeadSourceCampaign.name
  const apiPath = apiEntityPath
  return httpDelete({
    callingMn,
    apiPath,
    entityData,
  })
}
